"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
require('./../scss/sites/ome/ome.scss');
const index_1 = require("./../js/index");
const ome_1 = require("./../js/Sites/ome");
// Initialize scripts that are used in all websites
(0, index_1.Init)();
// Initialize O.ME specific scripts
(0, ome_1.InitOme)();
// Import styles and scripts included in coreweb packages
(0, index_1.ImportCoreweb)();
